"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledContainer = (0, styles_1.styled)(material_1.Box)({
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "stretch",
    width: "100%",
    overflowX: "auto",
    height: "100%",
});
//# sourceMappingURL=styled.js.map